
import { Drawer, Input, Select, Option, Switch } from "element-ui"
import cloneDeep from "lodash/cloneDeep"
import searchAddress from "@/components/drawer/searchAddress.vue"
import { getCurrentAddress, resetStoreInfo } from "@/utils/utils"
import { addAddress, modifyAddress } from "@/api/address"
import { trackShippingInfo } from "@/utils/track"

export default {
  components: {
    [Drawer.name]: Drawer,
    [Input.name]: Input,
    [Select.name]: Select,
    [Option.name]: Option,
    [Switch.name]: Switch,
    searchAddress
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    action: {
      type: String,
      default: "add"
    },
    page: {
      type: String,
      default: ""
    },
    addresses: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      drawer: this.visible,
      form: {
        id: null,
        consignee: "",
        areaCode: "",
        phone: "",
        address2: "",
        unitFloor: "",
        label: "",
        priority: false,
        lat: null,
        lng: null,
        address: "",
        type: null
      },
      activeSaveBtn: false,
      activeAddressInput: false,
      selectedAddress: {},
      activeLabel: {},
      areaCodeOptions: [
        {
          label: this.$t("auth.china"),
          value: "+86",
          maxlength: 11
        },
        {
          label: this.$t("auth.hongKong"),
          value: "+852",
          maxlength: 8
        },
        {
          label: this.$t("auth.macau"),
          value: "+853",
          maxlength: 8
        }
      ],
      labelOptions: [
        {
          name: this.$t("address.home"),
          value: "Home",
          icon: "Home"
        },
        {
          name: this.$t("address.office"),
          value: "Work",
          icon: "Work"
        },
        {
          name: this.$t("address.other"),
          value: "Other",
          icon: "Add"
        }
      ],
      searchAddressVisible: false,
      rules: {
        consignee: [{ validator: this.validateConsignee, trigger: "blur" }],
        phone: [{ validator: this.validatePhone, trigger: "blur" }],
        unitFloor: [{ validator: this.validateUnitFloor, trigger: "blur" }]
      },
      errors: {}
    }
  },
  watch: {
    visible(val) {
      this.drawer = val
      this.activeLabel = {}
      if (this.action == "edit" && this.addresses) {
        this.initAddress(this.addresses)
      } else {
        this.form = {
          id: null,
          consignee: "",
          areaCode: "+852",
          phone: "",
          address2: "",
          unitFloor: "",
          label: "",
          priority: false,
          lat: null,
          lng: null,
          address: "",
          type: null
        }
      }
    },
    form: {
      handler(nVal) {
        const { address2, unitFloor, phone, consignee, areaCode } = nVal
        if (address2 && unitFloor.trim() && phone && consignee.trim() && areaCode) {
          this.activeSaveBtn = true
        } else {
          this.activeSaveBtn = false
        }
      },
      deep: true
    }
  },
  methods: {
    initAddress(addresses) {
      if (addresses.mobilPhone && addresses.mobilPhone.includes(" ")) {
        addresses.areaCode = addresses.mobilPhone.split(" ")[0]
        addresses.phone = addresses.mobilPhone.split(" ")[1]
        if (!addresses.areaCode.includes("+")) {
          addresses.areaCode = "+" + addresses.areaCode
        }
      } else {
        addresses.phone = addresses.mobilPhone
        addresses.areaCode = ""
      }
      this.form = cloneDeep(addresses)
      this.form.priority = this.form.priority == "Default"
      if (!addresses.label) return
      this.activeLabel = {
        value: ["Home", "Work"].includes(addresses.label) ? addresses.label : "Other"
      }
    },
    handleChangeAreaCode() {
      this.validateField("phone", "blur")
    },
    validateConsignee(value) {
      if (value.length > 20) {
        return "限制 1-20 字符，支持中文、英文、數字及常見符號，禁止特殊字符"
      }
      if (this.isEmojiCharacter(value)) {
        return "收貨人姓名包含非法字符，請修改後提交"
      }
      return true
    },
    handlePhoneInput() {
      this.validateField("phone", "blur", false)
    },
    validatePhone(value) {
      this.form.phone = value.replace(/[^\d]/g, "")
      const { areaCode, phone } = this.form
      if (!areaCode) return "请选择区号"
      if (areaCode === "+86") {
        // 限制11位数 || 1开头
        if (phone.length !== 11 || !/^1\d{10}$/.test(phone)) {
          return this.$t("cart.recipientWarningTextWith11Digits")
        }
      } else {
        // 限制8位数
        if (phone.length !== 8) {
          return this.$t("cart.recipientWarningTextWith8Digits")
        }
      }
      return true
    },
    validateUnitFloor(value) {
      if (value.length > 200) {
        return "限制 1-200 字符，支持中文、英文、數字及常見符號，禁止特殊字符"
      }
      if (this.isEmojiCharacter(value)) {
        return "收貨地址包含特殊字符，請修改後提交"
      }
      return true
    },
    isEmojiCharacter(char) {
      // eslint-disable-next-line no-misleading-character-class
      const emojiRegex = /[\u{1F300}-\u{1F64F}|\u{1F680}-\u{1F6FF}|\u{200D}|\u{FE0F}]/u
      return emojiRegex.test(char)
    },
    showTitle() {
      return {
        add: this.$t("address.addNewAddress"),
        edit: this.$t("address.editAddress")
      }[this.action]
    },
    handleSearchAddress() {
      this.searchAddressVisible = true
    },
    handleSearchAddressClose() {
      this.searchAddressVisible = false
    },
    handleSelectAddress(item) {
      this.selectedAddress = item
      this.form.address2 = item.address
      this.form.areaName1 = item.province
      this.form.areaName2 = item.city
      this.form.areaName3 = item.district
      this.form.type = item.type
    },
    handleClose() {
      this.$emit("close")
      this.$refs.searchAddressRef?.handleClear()
    },
    handleSelectLabel(item) {
      this.activeLabel = item
      this.form.label = ""
    },
    handleBlur(trigger, fileName) {
      if (fileName === "address2") {
        this.activeAddressInput = false
      }
    },
    handleSave() {
      if (!this.activeSaveBtn) return
      this.errors = {}
      let isValid = true
      for (const fieldName in this.rules) {
        this.validateField(fieldName, "blur")
        if (this.errors[fieldName]) {
          isValid = false
        }
      }
      if (isValid) {
        this.submitForm()
      }
    },
    validateField(fieldName, trigger, isTips) {
      const fieldRules = this.rules[fieldName]
      if (!fieldRules) return
      this.$set(this.errors, fieldName, "")
      for (const rule of fieldRules) {
        if (trigger !== rule.trigger) return
        if (rule.validator) {
          const result = rule.validator(this.form[fieldName])
          if (result === true) return
          if (isTips) {
            this.$message({
              message: this.errors.consignee || result,
              type: "warning"
            })
          }
          this.$set(this.errors, fieldName, result)
          return
        }
      }
    },
    async submitForm() {
      const params = {
        address: "",
        address2: encodeURIComponent(this.form.address2),
        addressName: encodeURIComponent(this.selectedAddress.name || ""),
        unitFloor: encodeURIComponent(this.form.unitFloor.trim()),
        priority: this.form.priority ? "Default" : null,
        phone: this.form.areaCode + " " + this.form.phone,
        consignee: encodeURIComponent(this.form.consignee.trim()),
        label: encodeURIComponent(this.form.label || this.activeLabel.value || ""),
        lat: this.selectedAddress.latitude || this.form.lat,
        lng: this.selectedAddress.longitude || this.form.lng,
        areaName1: this.form.areaName1,
        areaName2: this.form.areaName2,
        areaName3: this.form.areaName3
      }
      let handleFun = addAddress
      if (this.action == "edit") {
        params.id = this.form.id
        params.type = this.form.type
        handleFun = modifyAddress
      }
      try {
        const { code, data } = await handleFun({ param: JSON.stringify(params) })
        if (code !== "0000") {
          this.$message({
            message: data?.msg || "delete fail",
            type: "warning"
          })
          return
        }
        this.$message({
          message: this.type == "edit" ? this.$t("address.addressUpdated") : this.$t("address.addressAdded"),
          type: "success"
        })
        const accountInfo = await this.$store.dispatch("getLoginInfo")
        const addresses = accountInfo?.address?.find(item => item.id === this.form.id)
        const currentAddress = getCurrentAddress()
        if (currentAddress?.id == this.form.id) {
          // 非购物车页面地址才执行该逻辑
          if (this.page !== "cart") {
            await resetStoreInfo(addresses, true)
          }
        }
        this.$emit("save", accountInfo)
        this.$refs.searchAddressRef?.handleClear()
        // TODO: 是否需要埋点
        trackShippingInfo(this.selectedAddress.address || this.addresses)
      } catch (error) {
        console.log("🚀 ~ submitForm ~ error:", error)
      }
    }
  }
}
